import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { scenarioTwoAPI } from 'api/scenarioTwoAPI';
import produce from 'immer';

export const fetchScenarioTwoStats = createAsyncThunk(
    'scenarioTwo/fetchScenarioTwoStats',
    async (params) => await scenarioTwoAPI.fetchStats(params)
);
export const fetchScenarioTwoOutliers = createAsyncThunk(
    'scenarioTwo/fetchScenarioTwoOutliers',
    async (params) => await scenarioTwoAPI.fetchOutliers(params)
);
export const fetchScenarioTwoBreachCategory = createAsyncThunk(
    'scenarioTwo/fetchScenarioTwoBreachCategory',
    async (params) => await scenarioTwoAPI.fetchBreachCategory(params)
);
export const fetchScenarioTwoTrendData = createAsyncThunk(
    'scenarioTwo/fetchScenarioTwoTrendData',
    async (params) => await scenarioTwoAPI.fetchTrendData(params)
);

export const fetchScenarioTwoTopFiveRmsData = createAsyncThunk(
    'scenarioTwo/fetchScenarioTwoTopFiveRmsData',
    async (params) => await scenarioTwoAPI.fetchTopFiveRms(params)
);

const scenarioTwoSlice = createSlice({
    name: 'scenarioTwo',
    initialState: {
        stats: null,
        outliersData: null,
        breachCategoryData: null,
        trendData: null,
        topFiveRmsData: null,
        detailedViewData: null,
        outliersIsFetched: false,
        breachCategoryIsFetched: false,
        trendIsFetched: false,
        topFiveRmsIsFetch: false,
        detailedViewIsFetched: false
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchScenarioTwoStats.fulfilled, (state, { payload }) =>
            produce(state, (draft) => {
                const { statsReporting } = payload;
                draft.stats = statsReporting;
            })
        );
        builder.addCase(
            fetchScenarioTwoOutliers.fulfilled,
            (state, { payload }) =>
                produce(state, (draft) => {
                    const { outlierData } = { ...payload };
                    draft.outliersData = outlierData;
                    draft.outliersIsFetched = true;
                })
        );
        builder.addCase(
            fetchScenarioTwoBreachCategory.fulfilled,
            (state, { payload }) =>
                produce(state, (draft) => {
                    draft.breachCategoryData = payload;
                    draft.breachCategoryIsFetched = true;
                })
        );
        builder.addCase(
            fetchScenarioTwoTrendData.fulfilled,
            (state, { payload }) =>
                produce(state, (draft) => {
                    draft.trendData = payload;
                    draft.trendIsFetched = true;
                })
        );
        builder.addCase(
            fetchScenarioTwoTopFiveRmsData.fulfilled,
            (state, { payload }) =>
                produce(state, (draft) => {
                    const {
                        topFiveConcentrationRmOutliers,
                        topFivePortfolioRmOutliers
                    } = payload;
                    draft.topFiveRmsData = {
                        concentration: topFiveConcentrationRmOutliers,
                        portfolio: topFivePortfolioRmOutliers
                    };
                    draft.topFiveRmsIsFetch = true;
                })
        );
    }
});

const { reducer: scenarioTwoReducer } = scenarioTwoSlice;
export default scenarioTwoReducer;
